<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 bg-dark-blue">
          <img src="/img/arrow-left-white.svg" class="mt-4" height="30" @click="$router.back()" />
          <h5 class="text-align-right white bold mt-3 mb-5">Deixe um comentário ou depoimento sobre sua experiência com
            o projeto.
          </h5>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-md-12 col-sm-12 p-5">
          <ValidationObserver ref="dados">
            <form>
              <ValidationProvider mode="passive" name="resposta" rules="required" v-slot="{ errors, classes }">
                <div class="field">
                  <textarea :style="data && 'color: #0D4275'" class="input" :class="classes" v-model="data"
                    @focus="clear" autocomplete="nope"></textarea>
                  <label :class="data && 'filled-textarea'">Escreva sua resposta</label>
                  <span class="invalid-feedback">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </form>
          </ValidationObserver>
        </div>
        <div class="bottom">
          <button class="continue-btn" :disabled="loading" @click.prevent="handle">
            <span>CONTINUAR </span>
          </button>
        </div>
      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="required" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Escolha uma das opções</h5>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <Loading v-if="loading" />
    <ModalSucesso :show="modalSucesso" @hide="modalSucesso = false" />

  </div>
</template>

<script>

import api from "../axiosConfig";
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
    ModalSucesso: () => import("./ModalSucesso.vue"),
  },
  data() {
    return {
      modalSucesso: false,
      data: undefined,
      loading: false,
      idUsuario: undefined,
    };
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.$router.push("/login");
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
    }
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    clear() {
      this.$nextTick(() => {
        this.$refs.dados.reset();
      });
    },


    async handle() {
      const valid = await this.$refs.dados.validate();
      if (!valid) return;

      await this.save();
    },

    async save() {
      try {
        this.loading = true;

        var payload = {
          usuarioId: this.idUsuario,
          perguntaId: "03039f6b-353d-406b-aa34-29baf0703ca3",
          descricao: this.data,
        };

        await api.post('/respostas', payload);

        this.loading = false;

        this.modalSucesso = true;
      } catch (error) {
        this.$refs.warning.open();
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.w-200 {
  width: 200px;
}
</style>
